import { LogEventTypes, ExecutionStates } from 'automation-ui-log-events/constants/LogEventConstants';
import { useAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { getActionHeaderTitle, getActionOutputsForTargetActionById, getClassicRecurAnnually } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { useGetIsUngated } from 'automation-ui-core/hooks/authHooks';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import ActionPreview from 'automation-ui-canvas/components/test-flow/ActionPreview';
import { useActionOutputs } from 'automation-ui-action-features/action-outputs/actionOutputHooks';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import ExtensionActionPreview from 'automation-ui-canvas/components/test-flow/ExtensionActionPreview';
import getIn from 'immutable-less/transmute/getIn';
import SkippedPreview from 'automation-ui-canvas/components/test-flow/SkippedPreview';
import ListBranchActionPreview from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/ListBranchActionPreview';
import ErrorBoundary from 'automation-ui-core/errors/ErrorBoundary';
import FormattedMessage from 'I18n/components/FormattedMessage';
import StaticBranchPreview from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/StaticBranchPreview';
import RandomBranchPreview from 'automation-ui-canvas/containers/flow-views/test-flow/simulation/RandomBranchPreview';
import { forwardRef, useContext } from 'react';
import styled from 'styled-components';
import FormattedDateTimeWithZones from 'automation-ui-i18n/FormattedDateTimeWithZones';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import ObjectNameReference from 'automation-ui-enrollment/components/filters/enrollment/generic-enrollment-table/ObjectNameReference';
import AuthContext from 'automation-ui-core/context/AuthContext';
import UIAlert from 'UIComponents/alert/UIAlert';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { Text } from 'foundations-components/components/Text';
export const HIGHLIGHT_CLASS_NAME = 'highlight';
import { H7 } from 'foundations-components/transitional/components/H7';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledSectionWrapper = styled.div.withConfig({
  displayName: "SimulatedActionExecutionEventV2__StyledSectionWrapper",
  componentId: "sc-1dfsai4-0"
})(["@keyframes fadeBackground{from{background-color:", ";}to{background-color:", ";}}&.", " > .simulated-action-accordion{animation:fadeBackground 2s;animation-fill-mode:forwards;}"], ({
  theme
}) => theme.color['fill-secondary-subtle'], ({
  theme
}) => theme.color['fill-surface-default'], HIGHLIGHT_CLASS_NAME);
const SimulatedActionExecutionEventV2 = ({
  event,
  flowObjectTypeId,
  flow,
  recordId,
  branchOverrideValue,
  setBranchOverrideValue,
  open,
  onOpenChange,
  viewData
}, ref) => {
  var _flow$createMetadata, _allExtensionsData$al;
  const {
    user
  } = useContext(AuthContext);
  const isUngated = useGetIsUngated();
  const {
    type
  } = event || {};
  const {
    data: allExtensionsData
  } = useAllExtensionDefinitions({
    objectType: flowObjectTypeId,
    createdSourceApp: (_flow$createMetadata = flow.createMetadata) === null || _flow$createMetadata === void 0 ? void 0 : _flow$createMetadata.sourceApp
  });
  const extensionDefinitions = (_allExtensionsData$al = allExtensionsData === null || allExtensionsData === void 0 ? void 0 : allExtensionsData.allExtensionDefinitions) !== null && _allExtensionsData$al !== void 0 ? _allExtensionsData$al : {};
  const {
    instanceOutputsByActionId,
    allOutputsByActionTypeId
  } = useActionOutputs(flow);
  const trackEvent = useTrackEvent();
  const handleGetActionOutputsForTargetActionById = (targetActionId, isNew = false) => getActionOutputsForTargetActionById({
    flow,
    allOutputsByActionTypeId,
    instanceOutputsByActionId,
    targetActionId,
    isNewAction: isNew
  });
  if (type === LogEventTypes.ACTION_EXECUTION) {
    var _firstAlert$getIcon, _firstAlert$getIcon2, _event$action$actionT, _event$action2;
    const getHeaderTitle = getActionHeaderTitle({
      flow,
      extensionDefinitions,
      isUngated
    });
    const actionLabel = getHeaderTitle(event.action);
    const actionType = getIn(['action', 'actionType'], event);
    const action = getIn(['action'], event);
    const {
      executionState
    } = event || {};
    const {
      simulateFlow,
      enrollType,
      isLoading
    } = viewData;
    const getActionPreview = () => {
      const defaultActionPreview = /*#__PURE__*/_jsx(ActionPreview, {
        logEvent: event,
        flowObjectTypeId: flowObjectTypeId,
        flow: flow,
        actionLabel: actionLabel,
        renderContentOnly: true,
        extensionDefinitions: extensionDefinitions,
        getHeaderTitle: getHeaderTitle,
        getActionOutputsForTargetActionById: handleGetActionOutputsForTargetActionById
      });
      switch (actionType) {
        case ActionTypes.LIST_BRANCH:
          return /*#__PURE__*/_jsx(ListBranchActionPreview, {
            logEvent: event,
            flow: flow,
            recordId: recordId,
            viewData: viewData,
            branchOverrideValue: branchOverrideValue,
            setBranchOverrideValue: setBranchOverrideValue
          });
        case ActionTypes.AB_TEST_BRANCH:
          return /*#__PURE__*/_jsx(RandomBranchPreview, {
            logEvent: event,
            flow: flow,
            recordId: recordId,
            branchOverrideValue: branchOverrideValue,
            setBranchOverrideValue: setBranchOverrideValue
          });
        case ActionTypes.STATIC_BRANCH:
          return /*#__PURE__*/_jsx(StaticBranchPreview, {
            logEvent: event,
            flow: flow,
            recordId: recordId,
            viewData: viewData,
            branchOverrideValue: branchOverrideValue,
            setBranchOverrideValue: setBranchOverrideValue,
            defaultActionPreview: defaultActionPreview
          });
        case ActionTypes.AUTOMATION_EXTENSION:
          return /*#__PURE__*/_jsx(ExtensionActionPreview, {
            action: action,
            actionLabel: actionLabel,
            flowObjectTypeId: flowObjectTypeId,
            getActionOutputsForTargetActionById: handleGetActionOutputsForTargetActionById,
            getHeaderTitle: getHeaderTitle,
            logEvent: event,
            renderContentOnly: true
          });
        case ActionTypes.EMAIL:
        case ActionTypes.CLASSIC_NOTIFICATION_EMAIL:
        case ActionTypes.EMAIL_NOTIFICATION:
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [defaultActionPreview, executionState === ExecutionStates.SKIPPED ? /*#__PURE__*/_jsx(SkippedPreview, {
              recursAnnually: getClassicRecurAnnually(flow)
            }) : null, /*#__PURE__*/_jsxs(UIAlert, {
              type: "tip",
              children: [/*#__PURE__*/_jsx(H7, {
                marginBlockEnd: "100",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.testV2.simulatePanel.sendEmail.title"
                })
              }), /*#__PURE__*/_jsx(HelpIcon, {
                display: "inline-block",
                color: "icon-primary-default",
                title: /*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: "automation.testV2.simulatePanel.sendEmail.tooltip",
                  options: {
                    recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
                      objectTypeId: flow.objectTypeId,
                      id: recordId
                    })
                  }
                }),
                children: /*#__PURE__*/_jsx(FormattedReactMessage, {
                  message: "automation.testV2.simulatePanel.sendEmail.description",
                  options: {
                    recordTitle: /*#__PURE__*/_jsx(ObjectNameReference, {
                      objectTypeId: flow.objectTypeId,
                      id: recordId
                    })
                  }
                })
              }), (user === null || user === void 0 ? void 0 : user.email) && /*#__PURE__*/_jsx("div", {
                className: "m-y-1",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.testV2.simulatePanel.sendEmail.sendTo",
                  options: {
                    email: user.email
                  }
                })
              }), /*#__PURE__*/_jsx(LoadingButton, {
                loading: isLoading,
                onClick: () => {
                  trackEvent(Trackables.SEND_EMAIL_PREVIEW);
                  simulateFlow({
                    flowId: flow.flowId,
                    objectId: recordId,
                    enrollType,
                    sendEmailsToUser: true
                  });
                },
                use: "tertiary",
                size: "small",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.testV2.simulatePanel.sendEmail.button"
                })
              })]
            })]
          });
        default:
          return /*#__PURE__*/_jsxs(_Fragment, {
            children: [defaultActionPreview, executionState === ExecutionStates.SKIPPED ? /*#__PURE__*/_jsx(SkippedPreview, {
              recursAnnually: getClassicRecurAnnually(flow)
            }) : null]
          });
      }
    };
    const firstAlert = viewData.alerts.flowAlerts.find(alert => {
      var _event$action;
      return alert.actionId === ((_event$action = event.action) === null || _event$action === void 0 ? void 0 : _event$action.actionId);
    });
    const timestamp = event.timestamp;
    const icon = /*#__PURE__*/_jsx(TFlex, {
      justify: "center",
      inlineSize: "28px",
      children: (_firstAlert$getIcon = firstAlert === null || firstAlert === void 0 || (_firstAlert$getIcon2 = firstAlert.getIcon) === null || _firstAlert$getIcon2 === void 0 ? void 0 : _firstAlert$getIcon2.call(firstAlert)) !== null && _firstAlert$getIcon !== void 0 ? _firstAlert$getIcon : /*#__PURE__*/_jsx(UIIcon, {
        name: "success"
      })
    });
    return (
      /*#__PURE__*/
      // @bend-expect trellis-tokenized
      _jsx(StyledSectionWrapper, {
        ref: ref,
        children: /*#__PURE__*/_jsx("div", {
          className: "simulated-action-accordion",
          children: /*#__PURE__*/_jsx(UIExpandableSection, {
            titleText: actionLabel,
            open: open,
            onOpenChange: onOpenChange,
            actions: /*#__PURE__*/_jsxs(_Fragment, {
              children: [timestamp && /*#__PURE__*/_jsx(Text, {
                as: "small",
                use: "help",
                display: "block",
                marginInlineEnd: "200",
                children: /*#__PURE__*/_jsx(FormattedDateTimeWithZones, {
                  value: timestamp,
                  format: "l LT z"
                })
              }), icon]
            }),
            children: /*#__PURE__*/_jsx(ErrorBoundary, {
              boundaryName: `SimulatedActionPreview_${(_event$action$actionT = (_event$action2 = event.action) === null || _event$action2 === void 0 ? void 0 : _event$action2.actionType) !== null && _event$action$actionT !== void 0 ? _event$action$actionT : 'enrollment'}`,
              renderError: () => /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation.testV2.simulatePanel.error"
              }),
              children: getActionPreview()
            })
          })
        })
      })
    );
  }
  return null;
};
export default /*#__PURE__*/forwardRef(SimulatedActionExecutionEventV2);